import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { configureClient } from "@starz/shared/api/client";
import { configureChatStream } from "@starz/shared/chat/useChatStream";

import "@/styles/globals.css";
import "@/lib/auth/amplify"; // configures Amplify Auth at module load
import { AppRoutes } from "@/routes";

configureClient({
  baseUrl: (import.meta.env.VITE_API_URL as string | undefined) ?? "http://localhost:8000",
});
configureChatStream({
  chatStreamUrl: (import.meta.env.VITE_CHAT_STREAM_URL as string | undefined) ?? "",
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
